<div class="min-h-screen bg-background">
  <app-header
    (trialClick)="redirectToRegister()"
    (loginClick)="redirectToLogin()"
  ></app-header>
  <main>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </main>
  <app-footer></app-footer>
  <app-contact-drawer
    [open]="contactOpen"
    (closeDrawer)="contactOpen = false"
  ></app-contact-drawer>
</div>
